import React from 'react';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import CollectionBlock from './CollectionBlock';
import s from './Collections.scss';
var Collections = function (_a) {
    var _b;
    var block = _a.block, parentDeviation = _a.deviation;
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block, headerClassName: s['header'] },
        React.createElement("div", null, (_b = block.collections) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
            var collection = _a.collection, deviations = _a.deviations;
            return collection &&
                deviations && (React.createElement(CollectionBlock, { key: collection.folderId, parentDeviation: parentDeviation, collection: collection, deviations: deviations }));
        }))));
};
Collections.displayName = 'Collections';
export default Collections;
//# sourceMappingURL=Collections.js.map